var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0005 10.6667C11.8205 10.6667 11.6471 10.5936 11.5271 10.4741C11.2605 10.215 11.2605 9.78995 11.5205 9.53092V9.52428L12.3777 8.674H2.66683V10.0024C2.66683 10.3677 2.36683 10.6666 2.00016 10.6666C1.62683 10.6666 1.3335 10.3677 1.3335 10.0024V8.00982V6.01737C1.3335 5.64543 1.62683 5.35319 2.00016 5.35319C2.36683 5.35319 2.66683 5.64543 2.66683 6.01737V7.34564H12.3908L11.5205 6.48236V6.47571C11.2538 6.21004 11.2538 5.79161 11.5205 5.53258C11.7805 5.26691 12.2005 5.26691 12.4671 5.53258L14.4671 7.52511V7.52445C14.5565 7.61118 14.6151 7.7183 14.6431 7.83206C14.6586 7.88847 14.6668 7.94804 14.6668 8.00982C14.6668 8.25131 14.5357 8.46378 14.3409 8.58006L12.4605 10.4535C12.3338 10.573 12.1605 10.6461 11.9871 10.6461L12.0005 10.6667Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightBar);
export default __webpack_public_path__ + "static/media/arrow-right-bar.f22e6857d725c0ae526a074aef39c7a5.svg";
export { ForwardRef as ReactComponent };